import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {Form, Col, Row, Divider, Transfer, Button, Modal, message} from "antd";
import WarehouseSelect from "../../components/warehouse/WarehouseSelect";
import {TransferStockStates} from "./types/TransferStockTypes";
import {stockApiService} from "../../services/otodis/StockApiService";
import {SaveOutlined} from "@ant-design/icons";

export interface TransferStockProps {

}

class TransferStock extends Component<TransferStockProps & any, TransferStockStates> {
    private readonly initState!: TransferStockStates;

    constructor(props: TransferStockProps & any | any) {
        super(props);

        this.initState = {
            submitting: false,
            loading: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            warehouseCodeSource: null,
            warehouseNameSource: "",
            warehouseCodeDestination: null,
            warehouseNameDestination: "",
            mockData: [],
            targetKeys: [],
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        this.setState({
            dealerCode: data.value,
            warehouseCodeSource: null,
            warehouseNameSource: "",
            warehouseCodeDestination: null,
            warehouseNameDestination: "",
        });
    }

    onWarehouseSourceChange = async (data: any) => {
        await this.promisedSetState({
            warehouseCodeSource: data.value,
            warehouseNameSource: data.children,
            mockData: [],
            targetKeys: [],
        });
        this.getMock();
    }

    onWarehouseDestinationChange = async (data: any) => {
        await this.promisedSetState({
            warehouseCodeDestination: data.value,
            warehouseNameDestination: data.children,
            targetKeys: [],
        });
    }

    getMock = () => {
        const mockDataTemp: any = [];
        stockApiService.getStock({
            dealerCode: this.state.dealerCode,
            statusStock: "ACTIVE",
            warehouseCode: this.state.warehouseCodeSource,
            liteRespone: true
        }).then(async value => {
            for (const item of value.data.data) {
                const data = {
                    key: item.stock_unit_code,
                    title: item.vehicle_engine_number,
                    description: item.vehicle_variant_name + " " + item.vehicle_color_code + " " + item.vehicle_variant_code,
                };
                mockDataTemp.push(data);
            }
            await this.promisedSetState({
                mockData: mockDataTemp,
            });
        }).catch(async reason => {
            console.log('NoData');
            message.error('Data Tidak Ditemukan');
        })
    };

    onSubmit = async () => {
        await this.promisedSetState({
            submitting: true,
        });

        if (!this.state.dealerCode || !this.state.warehouseCodeSource || !this.state.warehouseCodeDestination || !this.state.targetKeys.length) {
            await this.promisedSetState({
                submitting: false,
            });

            Modal.error({
                title: 'Proses Submit Gagal',
                content: 'Mohon periksa kembali data yang anda masukan.'
            });
            return false;
        }

        const input = {
            dealer_code: this.state.dealerCode,
            old_warehouse_code: this.state.warehouseCodeSource,
            new_warehouse_code: this.state.warehouseCodeDestination,
            data: this.state.targetKeys,
        }

        try {
            await stockApiService.changeWarehouseStock(
                input
            ).then(dataInsertStock => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Data berhasil diupdate'
                });
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            });
        } catch (e: any) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e.message
            });
            await this.promisedSetState({
                submitting: false,
            });
        }
    }

    handleChange = (targetKeys: any) => {
        this.setState({targetKeys});
    };

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Stock`} breadcrumbMenu={`Pindah Stock Gudang`} defaultSelectedKeys={['m-warehouse-stock-transfer']} defaultOpenKeys={['sm-stock', 'sm-sm-stock-warehouse']}>
                    <Row>
                        <Col xs={24} xl={12}>
                            <div className={`mid-pad-10`} style={{}}>
                                <Divider>Gudang Sumber</Divider>
                                <Form.Item>
                                    <WarehouseSelect onWarehouseChangeProps={this.onWarehouseSourceChange} dealerCode={this.state.dealerCode} value={this.state.warehouseCodeSource}/>
                                </Form.Item>
                            </div>
                        </Col>
                        <Col xs={24} xl={12}>
                            <div className={`mid-pad-10`} style={{}}>
                                <Divider>Gudang Tujuan</Divider>
                                <Form.Item>
                                    <WarehouseSelect onWarehouseChangeProps={this.onWarehouseDestinationChange} dealerCode={this.state.dealerCode} value={this.state.warehouseCodeDestination}/>
                                </Form.Item>
                            </div>
                        </Col>

                        <Col xs={24} xl={24} className={`pad-10`}>
                            <Transfer
                                dataSource={this.state.mockData}
                                showSearch
                                listStyle={{
                                    width: '100%',
                                    height: 580,
                                }}
                                targetKeys={this.state.targetKeys}
                                onChange={this.handleChange}
                                render={item => `${item.title}-${item.description}`}
                            />
                        </Col>

                        <Col span={24} className={`pad-10`}>
                            <Form.Item>
                                <Button type={'primary'}
                                        icon={<SaveOutlined/>}
                                        onClick={this.onSubmit}
                                        loading={this.state.submitting}>Simpan Data</Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(TransferStock), 4));
